// extracted by mini-css-extract-plugin
export default {"name":"CompleteInfoForm_name__41sPb","load":"CompleteInfoForm_load__2s-cG","skip":"CompleteInfoForm_skip__E5B-4"};